export default vm => ([
  {
    key: 'name',
    label: vm.$t('asset-information.asset-info.files.name'),
  },
  {
    key: 'uploadDateTime',
    label: vm.$t('asset-information.asset-info.files.upload-date-time'),
  },
  {
    key: 'size',
    label: vm.$t('asset-information.asset-info.files.size'),
    thClass: 'files__table-file-size',
  },
  {
    key: 'actions',
    label: '',
    thClass: 'files__table-actions',
  },
]);
